import { Button, Checkbox, Form, Input, Modal, Select } from 'antd'; // Import Select from Ant Design
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from '../../apis/ApiInterceptor';
import { fetchBranches } from '../../apis/branchApi';
import { getFeaturesForUser } from '../../apis/featureApi';
import { openNotification } from '../../components/notifications';

const { Option } = Select;

const RegisterForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [branches, setBranches] = useState([]); // State to store branch options
  const redirectTo = location.state?.from?.pathname || null;


  useEffect(() => {
    const loadBranches = async () => {
      setBranches(await fetchBranches());
    };

    loadBranches();
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await apiClient.post('/auth/register', values);
      if (response.status === 201) {
        const access_token = response.data.access_token;
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        const decodedToken = jwtDecode(access_token);
        const userId = decodedToken.sub;
        //Get User features
        const userFeatures = await getFeaturesForUser(values.branch, userId);
        localStorage.setItem('user_features', JSON.stringify(userFeatures));
        if (redirectTo) {
          navigate(redirectTo, { replace: true });
        } else {
          navigate('/home', { replace: true });
        }
        openNotification(
          "success",
          "",
          "Usuario registrado con éxito."
        );
      } else {
        openNotification(
          "Error",
          "Error de registro",
          "Contacta a soporte técnico."
        );
        console.log('Respuesta del servidor:', response.data);
      }
    } catch (error) {
      if (error.response?.data?.errno === 1062) {
        const duplicateValueMatch = error.response.data.msg.match(/Duplicate entry '(.+?)'/);
        const duplicateValue = duplicateValueMatch ? duplicateValueMatch[1] : 'valor duplicado';
        openNotification(
          "error",
          "Error de registro",
          `El valor '${duplicateValue}' ya está registrado. Por favor, utiliza otro.`
        );
      } else {
        console.error('Error al registrar el usuario:', error);
        openNotification(
          "error",
          "",
          "Hubo un error al registrar el usuario."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const showPdf = (event, type) => {
    event.preventDefault();
    const pdfFile =
      type === 'terms' ? '/pdf/terms_and_conditions.pdf' : '/pdf/informed_consent.pdf';
    setPdfUrl(pdfFile);
    setPdfModalVisible(true);
  };

  return (
    <div className="container my-5">
      <h2>Registro de Usuario</h2>
      <Form
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ terms_accepted: false }}
      >
        <Form.Item
          name="name"
          label="Nombre"
          rules={[{ required: true, message: 'Por favor, ingresa tu nombre.' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="phone"
          label="Celular"
          rules={[
            { required: true, message: "Por favor, ingresa tu número de celular" },
            { pattern: /^[0-9]{10}$/, message: "El celular debe tener 10 dígitos" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="email"
          label="Correo Electrónico"
          rules={[
            { required: true, message: 'Por favor, ingresa tu correo.' },
            { type: 'email', message: 'Por favor, ingresa un correo válido.' },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="password"
          label="Contraseña"
          rules={[{ required: true, message: 'Por favor, ingresa tu contraseña.' }]}
        >
          <Input.Password />
        </Form.Item>
        {branches.length > 1 ? (
          <Form.Item
            name="branch"
            label="Sucursal"
            rules={[{ required: true, message: 'Por favor, selecciona una sucursal.' }]}
          >
            <Select placeholder="Selecciona una sucursal">
              {branches.map((branch) => (
                <Option key={branch.id} value={branch.id}>
                  {branch.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        ) : (
          branches.length === 1 && (
            // Automatically set the branch value in the form without rendering an input
            <Form.Item name="branch" initialValue={branches[0].id} hidden>
              <Input />
            </Form.Item>
          )
        )}
        
        <Form.Item
          name="terms_accepted"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(new Error('Debes aceptar los términos y condiciones.')),
            },
          ]}
        >
          <Checkbox>
            Acepto los{' '}
            <button
              type="button"
              onClick={(event) => showPdf(event, 'terms')}
              className="link-button"
            >
              Términos y Condiciones
            </button>{' '}
            y el{' '}
            <button
              type="button"
              onClick={(event) => showPdf(event, 'consent')}
              className="link-button"
            >
              Consentimiento Informado
            </button>.
          </Checkbox>
        </Form.Item>
        <div className='d-flex'>
          <Button className='btn themed-btn ml-auto' type="primary" htmlType="submit" loading={loading}>
            Registrarme
          </Button>
        </div>
      </Form>

      <Modal
        open={pdfModalVisible}
        footer={null}
        onCancel={() => setPdfModalVisible(false)}
        width={800}
      >
        <iframe title='legal pdf' src={pdfUrl} width="100%" height="500px" />
      </Modal>
    </div>
  );
};

export default RegisterForm;
